import React from 'react';
import './LoadingFullView.css'; // Import the CSS for styling

export const LoadingFullView = () => {
  return (
    <div className="loading-container">
      <h1 className="loading-heading">Group Therapy</h1>
      <div className="stylish-loading-circle"></div> {/* Stylish rotating circle */}
    </div>
  );
};

export default LoadingFullView;
